import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Typography, Box } from '@mui/material';
import GenericTable from './GenericTable';
import { entrepriseCandidatureStatus } from './constants/options';

const InfosComplementaires = ({ candidatures = [], viewerType }) => {
  const navigate = useNavigate();
  const [displayMode, setDisplayMode] = useState('table'); // ✅ Ajout

  const columns = [
    {
      key: 'reference',
      label: 'Référence',
      render: (_, row) => row.candidatId?.reference || 'N/A',
    },
    ...(viewerType === 'entreprise'
      ? [
          {
            key: 'recruteur',
            label: 'Recruteur',
            render: (_, row) =>
              `${row.recruteur?.firstName || ''} ${row.recruteur?.lastName || ''}`.trim() || 'N/A',
          },
        ]
      : []),
    {
      key: 'tarif',
      label: 'Tarif',
      render: (_, row) => {
        const devise = row.devise || '';
        const montant = row.tarif ? String(row.tarif).replace(/"/g, '') : '—';
        return `${montant} ${devise}`.trim();
      },
    },
    {
      key: 'statut',
      label: 'Statut',
      render: (_, row) => {
        const rawStatus = row.statut || 'Inconnu';
        const overrideLabel =
        rawStatus === 'A traiter' || rawStatus === 'Candidature envoyée'
          ? 'Candidature envoyée'
          : null;
  
      const matchedStatus = entrepriseCandidatureStatus.find((s) => s.value === rawStatus);
  
        return (
          <span className="status-cell" style={matchedStatus?.style}>
        {overrideLabel || matchedStatus?.label || rawStatus}
        </span>
        );
      },
    },
    {
      key: 'dateEnvoi',
      label: 'Date de candidature',
      render: (value) => new Date(value).toLocaleDateString('fr-FR'),
    },
  ];

    const filteredCandidatures =
      viewerType === 'entreprise'
               ? candidatures.filter(c => c.statut?.toLowerCase() !== 'brouillon')
                  : candidatures;


  const renderActions = (row) => {
    const isBrouillon = row.statut?.toLowerCase() === 'brouillon';
    const missionId = row.missionId?._id || row.missionId; // adjust depending on your data structure
    const talentId = row.candidatId?._id || row.candidatId; // same here
  
    const basePath = viewerType === 'entreprise' ? 'Entreprise' : 'Recruteur';
  
    const handleClick = () => {
      if (isBrouillon) {
        // Open in new tab
        window.open(`/recruteur/travailler-mission/${missionId}?t=${talentId}`, '_blank');
      } else {
        // Navigate normally
        navigate(`/${basePath}/DetailsCandidature/${row._id}`);
      }
    };
  
    return (
      <button
        className={`btn-small ${isBrouillon ? 'resume-button' : 'details-button'}`}
        onClick={handleClick}
      >
        {isBrouillon ? 'Reprendre' : 'Détails'}
      </button>
    );
  };
  

  return (
    <Box className="mission-container">
      <Typography variant="h6" mb={2} className="section-title">
        Suivi des candidatures
      </Typography>
      {candidatures.length === 0 ? (
        <Typography variant="body2" fontStyle="italic" className="no-candidature-text">
          Aucune candidature envoyée pour cette mission.
        </Typography>
      ) : (
        <GenericTable
          columns={columns}
          data={filteredCandidatures}
          renderActions={renderActions}
          displayMode={displayMode}           
          setDisplayMode={setDisplayMode}     
        />
      )}
    </Box>
  );
};

export default InfosComplementaires;
